import React from 'react';
import { Grid } from 'components/ui';
import { IndexListItemHeader } from 'components/styles_components/list';
import { FormattedMessage } from 'react-intl';
import useMobile from 'hooks/use_mobile';

const ListHeader = () => {
  const isMobile = useMobile();

  if (isMobile) {
    return null;
  }

  return (
    <IndexListItemHeader>
      <Grid container justifyContent="center" alignItems="center" spacing={2}>
        <Grid size={{ xs: 3 }} textAlign="left">
          <FormattedMessage id="ip" />
        </Grid>
        <Grid size={{ xs: 3 }} textAlign="left">
          <FormattedMessage id="browser.name" />
        </Grid>
        <Grid size={{ xs: 3 }} textAlign="left">
          <FormattedMessage id="browser.version" />
        </Grid>
        <Grid size={{ xs: 3 }} textAlign="right">
          <FormattedMessage id="actions" />
        </Grid>
      </Grid>
    </IndexListItemHeader>
  );
};

export default ListHeader;
